import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { eventConfig } from "@/config/eventConfig";

// Vertical (9:16) Vimeo promo in a compact modal. No autoplay: unmuted
// autoplay inside a cross-origin iframe is blocked on iOS/Safari, so we rely
// on Vimeo's own poster + play button. The iframe unmounts on close so audio
// never lingers.
export const VideoDialog = ({ open, onOpenChange }) => {
  const { video } = eventConfig;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="video-dialog"
        className="w-[min(92vw,420px)] max-w-none p-0 overflow-hidden rounded-[28px] border-0 bg-[#071524] shadow-[0_30px_90px_rgba(0,0,0,0.6)] [&>button]:text-white [&>button]:bg-black/40 [&>button]:rounded-full [&>button]:p-1.5 [&>button]:opacity-90 [&>button]:z-10"
      >
        <DialogTitle className="sr-only">{video.title}</DialogTitle>
        <DialogDescription className="sr-only">{video.supporting}</DialogDescription>
        <div className="relative w-full" style={{ aspectRatio: "9 / 16" }}>
          {open && (
            <iframe
              data-testid="video-dialog-iframe"
              src={video.embedUrl}
              title={video.title}
              className="absolute inset-0 h-full w-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              allowFullScreen
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoDialog;
